import React from 'react'
import { useTranslation } from 'react-i18next'

import Container from '@mui/material/Container'
import { CircularProgress } from '@mui/material'

import { useContextHook } from '../store/context'
import UserSettings from '../components/settings/userSettings'
import ChangePassword from '../components/settings/changePassword'
import { setPageTitle } from '../utils/service'

const SettingsView = (): JSX.Element => {
  const { t } = useTranslation()
  const { state } = useContextHook()
  const [isChangePasswordVisible, setIsChangePasswordVisible] = React.useState<boolean>(false)

  // update page title
  React.useEffect(() => {
    setPageTitle(t('settingsview.usersettings'))
  }, [t])

  return (
    <Container component="main">
      {state.user && !isChangePasswordVisible && (
        <UserSettings user={state.user} onChangePassword={() => setIsChangePasswordVisible(true)} />
      )}
      {state.isLoadingUser && <CircularProgress />}
      {state.user && isChangePasswordVisible && (
        <ChangePassword userId={state.user.id} onClose={() => setIsChangePasswordVisible(false)} />
      )}
    </Container>
  )
}

export default SettingsView
